const giftCards = "/gift-cards";
const workforce = "/workforce";
const settings = "/settings";
const crypto = "/crypto";
const promo = '/promo';


// ========== AUTHS ROUTES ================
export const LOGIN = "/login";
export const DASHBOARD = "/dashboard";
export const DASHBOARD_TRANS = '/dashboard/transactions'
export const CUSTOMERS = "/customers";
export const CUSTOMER = "/customers/:id"
export const FORGOTPASSWORD = "/forgot-password"
export const RESETPASSWORD = "/reset-password"

// ========== GIFTCARDS ROUTES ===============
export const GIFTCARDSTORE = `${giftCards}/stores`
export const GIFTCARDCATEGORY = `${giftCards}/categories`
export const GIFTCARDPREFERENCE = `${giftCards}/preference`
export const STOREGIFTCARD = `${giftCards}/stores/:id`
export const GIFTCARDSTATS = `${giftCards}/statistics`
export const GIFTCARDTRANSACTIONS = `${giftCards}/transactions`

//============= CRYPTO-TRADES ROUTES ===================

export const CRYPTO_transactionS = `${crypto}/transactions`
export const CRYPTO_TRADES = `${crypto}/trades`
export const CRYPTO_MANAGER = `${crypto}/manager`

//================= PROMO COUPONS AND TUTORIALS AND BONUSES ROUTES =============

export const PROMOTIONS = `${promo}/promotions`;
export const TUTORIALS = `${promo}/tutorials`;
export const BONUSES = `${promo}/bonuses`;
export const BANNERS = `${promo}/banners`;
export const COUPONS = `${promo}/coupons`;
export const RANKING = `${promo}/rankings`;
export const HOTTEST = `${promo}/hottest`;
export const TOP_TRADERS = `${promo}/rankings/traders`
export const ADD_BONUS = `${promo}/bonuses/add`

// ============ WORKFORCE ROUTES ==============
export const TEAMS = `${workforce}/teams`
export const TEAM = `${workforce}/team/:id`
export const ADMINS = `${workforce}/admins`
export const AUDIT = `${workforce}/audits`

// ========= SETTINGS ROUTES ===========
export const PROFILE = `${settings}/profile`
export const CHANGEPASSWORD = `${settings}/change-password`
export const CHANGEPIN = `${settings}/change-pin`

// ============ TRANSACTIONS ROUTES =========
export const TRANSACTIONS = "/transactions"
export const WITHDRAWALS = "/withdrawals"

// ========== APP MANAGER ROUTE =============
export const APPSETTINGS = "/app/settings";
export const APPNOTIFICATIONS = "/app/notification"
